import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getOcrLabIndividuals = (
  constructGet: ConstructGet,
  uuid: string,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructGet<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/ocr-lab-request/list-individuals/${uuid}`,
    {},
  );
